import CaseFileUpload from './common/CaseFileUpload';
import { partyCardFrameClasses } from './common/listItemClasses';

const sectionClasses = partyCardFrameClasses;
const supportingDocsAccept = 'application/pdf';

const LifeCarePlanSupportingDocumentsSection = ({ files, isUploading, removingFileId, handleFileSelection, handleRemoveFile, disabled = false }) => {
    return (
        <div className={sectionClasses}>
            <CaseFileUpload
                label="Supporting Life Care Plan Documents (optional)"
                uploadButtonText="Upload File"
                files={files}
                multiple
                accept={supportingDocsAccept}
                inputName="supporting-lifecare-document-file"
                onFileSelect={handleFileSelection}
                onRemove={handleRemoveFile}
                isLoading={isUploading || !!removingFileId}
                disabled={disabled}
            />
        </div>
    );
};

export default LifeCarePlanSupportingDocumentsSection;
